module.exports = __webpack_public_path__ + "dceca7330cd0ec93d6f3d4e965514a9f.png";